// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-notificacao {
    position: relative;
    display: inline-block;
}

.container-notificacao svg {
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    padding: 0.2rem;
    fill: var(--branco-padrao);
    transition: all .2s ease-in-out;
    border-radius: 50%;
    z-index: 20000;
}

.container-notificacao svg:hover {
    background-color: var(--branco-padrao);
    fill: var(--azul-dixi);
}

.badge-notificacao {
    position: absolute;
    top: -0.05rem;
    right: -0.05rem;
    background-color: red;
    color: var(--branco-padrao);
    width: .7rem;
    height: .7rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.7rem;
    font-weight: bold;
    padding: 0.2rem;
}

#mostra-tudo {
    background-color: var(--branco-padrao);
    fill: var(--azul-dixi);
}

.container-bloco-notificacoes {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.notificacoes-lista {
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: .5rem;
    top: 3rem;
    left: -22.8rem;
    background-color: var(--branco-padrao);
    box-shadow: 0 0 1rem rgba(0, 0, 0, .2);
    width: 25rem;
    max-height: 20rem;
    border-radius: 1rem;
    padding: .5rem;
    text-align: center;
    overflow-y: auto;
    scrollbar-width: none;
}

.cabecalho-bloco-notificacoes {
    width: 100%;
    display: flex;
    padding: 0 1rem;
    align-items: center;
    justify-content: space-between;
}

.quantidade-notificacoes {
    display: flex;
    align-items: center;
    gap: .3rem;
    margin-top: .5rem;
    font-weight: 500;
    font-size: 1rem;
    color: var(--text-color3);
}

.quantidade-notificacoes-numero {
    color: var(--azul-dixi);
}

.botao-ler-todas-notificacoes {
    background-color: var(--azul-dixi);
    color: var(--branco-padrao);
    padding: .5rem;
    border-radius: .5rem;
    margin-top: .5rem;
    cursor: pointer;
    border: none;
    outline: none;
    transition: all .2s ease-in-out;
}

.botao-ler-todas-notificacoes:hover {
    background-color: var(--botao-hover);
}

.divisor-cabecalho-notificacoes {
    width: 90%;
    background-color: var(--cinza-claro);
    margin: .7rem 0;
    margin-bottom: 0.5rem;
    opacity: .4;
}

.notificacao-item {
    padding: 1rem;
    transition: all .2s;
    border-radius: 1rem;
}

.notificacao-item:hover {
    background-color: var(--cinza-claro);
    cursor: pointer;
}

.notificacao-atuador {
    font-weight: bold;
}

.notificacao-acao {
    color: var(--text-color);
}

.notificacao-assunto {
    font-weight: bold;
    color: var(--azul-dixi);
}

.notificacao-assunto:hover {
    font-weight: bold;
    color: var(--azul-dixi);
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/Notificacao/Notificacao.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,+BAA+B;IAC/B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,cAAc;IACd,sCAAsC;IACtC,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,oCAAoC;IACpC,eAAe;IACf,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,0BAA0B;AAC9B","sourcesContent":[".container-notificacao {\n    position: relative;\n    display: inline-block;\n}\n\n.container-notificacao svg {\n    width: 2rem;\n    height: 2rem;\n    cursor: pointer;\n    padding: 0.2rem;\n    fill: var(--branco-padrao);\n    transition: all .2s ease-in-out;\n    border-radius: 50%;\n    z-index: 20000;\n}\n\n.container-notificacao svg:hover {\n    background-color: var(--branco-padrao);\n    fill: var(--azul-dixi);\n}\n\n.badge-notificacao {\n    position: absolute;\n    top: -0.05rem;\n    right: -0.05rem;\n    background-color: red;\n    color: var(--branco-padrao);\n    width: .7rem;\n    height: .7rem;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.7rem;\n    font-weight: bold;\n    padding: 0.2rem;\n}\n\n#mostra-tudo {\n    background-color: var(--branco-padrao);\n    fill: var(--azul-dixi);\n}\n\n.container-bloco-notificacoes {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.notificacoes-lista {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    gap: .5rem;\n    top: 3rem;\n    left: -22.8rem;\n    background-color: var(--branco-padrao);\n    box-shadow: 0 0 1rem rgba(0, 0, 0, .2);\n    width: 25rem;\n    max-height: 20rem;\n    border-radius: 1rem;\n    padding: .5rem;\n    text-align: center;\n    overflow-y: auto;\n    scrollbar-width: none;\n}\n\n.cabecalho-bloco-notificacoes {\n    width: 100%;\n    display: flex;\n    padding: 0 1rem;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.quantidade-notificacoes {\n    display: flex;\n    align-items: center;\n    gap: .3rem;\n    margin-top: .5rem;\n    font-weight: 500;\n    font-size: 1rem;\n    color: var(--text-color3);\n}\n\n.quantidade-notificacoes-numero {\n    color: var(--azul-dixi);\n}\n\n.botao-ler-todas-notificacoes {\n    background-color: var(--azul-dixi);\n    color: var(--branco-padrao);\n    padding: .5rem;\n    border-radius: .5rem;\n    margin-top: .5rem;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    transition: all .2s ease-in-out;\n}\n\n.botao-ler-todas-notificacoes:hover {\n    background-color: var(--botao-hover);\n}\n\n.divisor-cabecalho-notificacoes {\n    width: 90%;\n    background-color: var(--cinza-claro);\n    margin: .7rem 0;\n    margin-bottom: 0.5rem;\n    opacity: .4;\n}\n\n.notificacao-item {\n    padding: 1rem;\n    transition: all .2s;\n    border-radius: 1rem;\n}\n\n.notificacao-item:hover {\n    background-color: var(--cinza-claro);\n    cursor: pointer;\n}\n\n.notificacao-atuador {\n    font-weight: bold;\n}\n\n.notificacao-acao {\n    color: var(--text-color);\n}\n\n.notificacao-assunto {\n    font-weight: bold;\n    color: var(--azul-dixi);\n}\n\n.notificacao-assunto:hover {\n    font-weight: bold;\n    color: var(--azul-dixi);\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
